import { Button, useModal } from "@newsela/angelou";
import {
  actionNames,
  actionPrefixes,
  objectTypes,
  withTrackEvent,
} from "@newsela/snitch";

import { IPageViewModelStandard } from "@/types/models/ContentPageViewModel.interface";
import ContentDisplayDetailsRow from "@/view/ContentDisplay/ContentDisplayDetails/ContentDisplayDetailsRow";
import GeniusStandardsModal from "./GeniusStandardsModal";
import { standardsCss } from "./GeniusStandardsRow.style";
import type { GenerationGeniusContent } from "@/view/GeniusContent/GeniusContent.interface";

interface GeniusStandardsRowProps {
  standards: IPageViewModelStandard[];
  content: GenerationGeniusContent;
}

const ButtonWithTrackEvent = withTrackEvent(Button);

const GeniusStandardsRow = ({
  standards,
  content,
}: GeniusStandardsRowProps) => {
  const [modalProps, setActive, triggerRef] = useModal(false);

  if (!standards || standards.length === 0) return null;

  const standardsLabel = `Standards (${standards.length})`;

  const getStandardsValue = () => {
    const standardNames = standards.map((standard) => standard.name);
    const isTruncatedList = standardNames.length > 3;
    const standardsText =
      standardNames.length > 3
        ? standardNames.slice(0, 3).join(", ") + "..."
        : standardNames.join(", ");
    return (
      <>
        <span css={standardsCss}>{standardsText}</span>
        <ButtonWithTrackEvent
          flavor={Button.flavors.tertiary}
          size={Button.sizes.md}
          onClick={() => setActive(true)}
          ref={triggerRef}
          objectType={objectTypes.content}
          actionName={actionNames.interact}
          actionPrefix={actionPrefixes.initiate}
          streamProperties={{
            description: "Show standards modal on view page",
            content_id: content.id,
            content_type: "GenerationGeniusVideo",
          }}
        >
          {isTruncatedList ? "View all" : "View details"}
        </ButtonWithTrackEvent>
      </>
    );
  };

  const standardsRowData = [
    { label: standardsLabel, value: getStandardsValue() },
  ];

  return (
    <>
      <ContentDisplayDetailsRow row={standardsRowData} />
      <GeniusStandardsModal
        standards={standards}
        standardsLabel={standardsLabel}
        setActive={setActive}
        modalProps={modalProps}
      />
    </>
  );
};

export default GeniusStandardsRow;
